import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_URL;

const BASE_URL = `${apiUrl}authentication`; 

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const createCallStatus = async (data) => {
  try {
    const response = await apiClient.post('/call-status/', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || 'Error creating call status';
  }
};

export const updateCallStatus = async (userId, data) => {
  try {
    const response = await apiClient.put(`/call-status/${userId}/`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || 'Error updating call status';
  }
};

export const deleteCallStatus = async (userId) => {
  try {
    const response = await apiClient.delete(`/call-status/${userId}/delete/`);
    return response.data;
  } catch (error) {
    throw error.response?.data || 'Error deleting call status';
  }
};

export const getCallStatus = async (userId) => {
  try {
    let url = '/call-status/get/';
    if (userId) {
      url += `?user_id=${userId}`;
    }
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    throw error.response?.data || 'Error fetching call status';
  }
};